import { IMedia } from "./media";
import { IProperties, Status } from "./property";

export enum ListingStatus {
    SOLD = 'sold',
    AVAILABLE = 'available',
    
  }
export enum propertyType {
      LISTING = "LISTINGS",
      INVESTMENT = "INVESTMENTS",
      map = "map",
    }

export interface IListings{
_id:string,
property:string|IProperties,
 price:number,
 createdBy:string,
 documents:Partial<IMedia>[]|string[],
 floorplan:Partial<IMedia>|string,
 listingStatus:ListingStatus,
 status:Status,
 isActive:boolean

}